/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Assignment_Email_Prompt_TitleInputs */

const en_explorer_assignment_email_prompt_title = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send email notification?`)
};

const fr_explorer_assignment_email_prompt_title = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer une notification par e-mail ?`)
};

const de_explorer_assignment_email_prompt_title = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Benachrichtigung senden?`)
};

const it_explorer_assignment_email_prompt_title = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviare una notifica via email?`)
};

const ru_explorer_assignment_email_prompt_title = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить уведомление по электронной почте?`)
};

const es_explorer_assignment_email_prompt_title = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Enviar notificación por correo?`)
};

const zh_cn2_explorer_assignment_email_prompt_title = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送电子邮件通知？`)
};

const ja_explorer_assignment_email_prompt_title = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールで通知しますか？`)
};

const hi_explorer_assignment_email_prompt_title = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल सूचना भेजें?`)
};

const pt_pt2_explorer_assignment_email_prompt_title = /** @type {(inputs: Explorer_Assignment_Email_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar notificação por e-mail?`)
};

/**
* | output |
* | --- |
* | "Send email notification?" |
*
* @param {Explorer_Assignment_Email_Prompt_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_prompt_title = /** @type {((inputs?: Explorer_Assignment_Email_Prompt_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Prompt_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_assignment_email_prompt_title(inputs)
	if (locale === "de") return de_explorer_assignment_email_prompt_title(inputs)
	if (locale === "it") return it_explorer_assignment_email_prompt_title(inputs)
	if (locale === "ru") return ru_explorer_assignment_email_prompt_title(inputs)
	if (locale === "es") return es_explorer_assignment_email_prompt_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_assignment_email_prompt_title(inputs)
	if (locale === "ja") return ja_explorer_assignment_email_prompt_title(inputs)
	if (locale === "hi") return hi_explorer_assignment_email_prompt_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_assignment_email_prompt_title(inputs)
	return en_explorer_assignment_email_prompt_title(inputs)
});